import React, { Component } from 'react';
import {Dummy} from '../';
import styles from './style.css';
var classNames = require('classnames');
export default class Status extends Dummy {

    render() {
        var statusClass = {};
        var norm = this.getPsValue(this.props.ps[0]);
        var low = this.getPsValue(this.props.ps[1]);
        var high = this.getPsValue(this.props.ps[2]);

        var error = (norm.cleaned+low.cleaned+high.cleaned != 1);
        var disabled = low.disabled || high.disabled || norm.disabled;
        statusClass[styles.norm] = norm.cleaned && !error && !disabled;
        statusClass[styles.avar] = (low.cleaned || high.cleaned || error) && !disabled;
        statusClass[styles.disabled] = disabled;

        let vClass = classNames(styles.status, statusClass);
        return (
            <th className={vClass}  id={this.props.div_id}>
                {
                    (()=> {
                        if (error) {
                            return 'Ошибка';
                        }
                        else if (disabled) {
                            return '?';
                        }
                        else {
                            if (low.cleaned) {
                                return 'Низкий';
                            }
                            if (norm.cleaned) {
                                return 'В норме';
                            }
                            if (high.cleaned) {
                                return 'Авария';
                            }
                        }
                    })()
                }
            </th>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/entries/StatusBA/index.jsx